module.exports = __webpack_public_path__ + "img/Recycler2.3565738e.png";